import { AppDeployment } from '@atlassian/mpac-types';
import { AtlassianProductHostingTypeValues } from '@atlassian/mpac-types/dist/GraphQLGateway.gql.types';
import { OptionalLink } from '@atlassian/mpac-ui';
import React from 'react';
import CloudAppInstallationSteps from "../CloudAppInstallationSteps";
import FallbackInstallationDocumentation from "../FallbackInstallationDocumentation";
import InstructionalAppInstallationSteps from "../InstructionalAppInstallationSteps";
import ServerOrDatacenterInstallationSteps from "../ServerOrDatacenterInstallationSteps";
import { getCompatibleProductName } from "../utils";

const InstallationSteps = props => {
  const {
    appName,
    compatibleProducts,
    deploymentType,
    documentationUrl,
    hosting,
    installationInstructions,
    paymentModel,
    versionHistoryUrl,
    versionCount
  } = props;
  const productName = getCompatibleProductName(compatibleProducts);

  if (deploymentType === AppDeployment.INSTRUCTIONAL) {
    return /*#__PURE__*/React.createElement(InstructionalAppInstallationSteps, {
      instructions: installationInstructions,
      documentationUrl: documentationUrl,
      appName: appName
    });
  }

  if (deploymentType === AppDeployment.WORKFLOW) {
    return /*#__PURE__*/React.createElement(FallbackInstallationDocumentation, {
      appName: appName,
      documentationUrl: documentationUrl
    });
  }

  if (hosting === AtlassianProductHostingTypeValues.Server || hosting === AtlassianProductHostingTypeValues.DataCenter) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ServerOrDatacenterInstallationSteps, {
      appName: appName,
      compatibleProducts: compatibleProducts,
      deploymentType: deploymentType,
      paymentModel: paymentModel,
      productName: productName
    }), versionCount > 1 && /*#__PURE__*/React.createElement("p", null, "To find older ", /*#__PURE__*/React.createElement("em", null, appName), " versions compatible with your instance, you can look through our", ' ', /*#__PURE__*/React.createElement(OptionalLink, {
      href: versionHistoryUrl,
      title: "".concat(appName, "'s version history"),
      external: false
    }, "version history page"), "."));
  }

  if (hosting === AtlassianProductHostingTypeValues.Cloud) {
    return /*#__PURE__*/React.createElement(CloudAppInstallationSteps, {
      deploymentType: deploymentType,
      appName: appName,
      paymentModel: paymentModel,
      productName: productName
    });
  }

  return /*#__PURE__*/React.createElement(FallbackInstallationDocumentation, {
    appName: appName,
    documentationUrl: documentationUrl
  });
};

export default InstallationSteps;